import store from '@/store';
export function authHeader() {
    // return authorization header with jwt token
    let user = store?.state?.user?.user;
    let token = window?.$cookies?.get('Authorization');

    if (user && token) {
        return { 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}
